<template>
  <div class="mb-2">
    <b-row>
      <b-col
        lg="3"
        md="3"
      >
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 358 144"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <foreignObject
            width="100%"
            height="100%"
            x="25"
            y="25"
          >
            <div>
              <b-img
                src="@/assets/images/icons/count1.svg"
              />
            </div>
          </foreignObject>
          <foreignObject
            width="100%"
            height="100%"
            x="70"
            y="25"
          >
            <div>
              <span style="font-size:20px; font-weight: 600; color: #fff;">ปริมาณยานพาหนะทั้งหมด</span>
            </div>
          </foreignObject>
          <foreignObject
            x="20"
            y="70"
            width="100%"
            height="100%"
            color="#ffffff"
          >
            <span style="text-align:left; font-weight: 700; font-size:40px">
              {{ Total }}
            </span>
            <span
              style="text-align:center; font-weight: 600; font-size:20px"
            >
              คัน/วัน
            </span>
          </foreignObject>
          <path
            d="M16.5 143.5L1 128V8.5H318.693L331.5 0.5H357V8.5V128L341.5 143.5H16.5Z"
            stroke="#00B058"
          />
          <path
            d="M324.5 0H328.5L317.5 7H313.5L324.5 0Z"
            fill="#00B058"
          />
          <path
            d="M317.5 0H321.5L310.5 7H306.5L317.5 0Z"
            fill="#00B058"
          />
          <path
            d="M310.5 0H314.5L303.5 7H299.5L310.5 0Z"
            fill="#00B058"
          />
          <path
            d="M303.5 0H307.5L296.5 7H292.5L303.5 0Z"
            fill="#00B058"
          />
          <path
            d="M296.5 0H300.5L289.5 7H285.5L296.5 0Z"
            fill="#00B058"
          />
          <path
            d="M289.5 0H293.5L282.5 7H278.5L289.5 0Z"
            fill="#00B058"
          />
        </svg>
      </b-col>
      <b-col
        lg="3"
        md="3"
      >
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 358 144"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <foreignObject
            width="100%"
            height="100%"
            x="25"
            y="25"
          >
            <div>
              <b-img
                src="@/assets/images/icons/count2.svg"
              />
            </div>
          </foreignObject>
          <foreignObject
            width="100%"
            height="100%"
            x="70"
            y="25"
          >
            <div>
              <span style="font-size:20px; font-weight: 600; color: #fff;">ยานพาหนะสูงสุด</span>
            </div>
          </foreignObject>
          <foreignObject
            x="20"
            y="70"
            width="100%"
            height="100%"
            color="#ffffff"
          >
            <span style="font-size: 24px; color: #F9E6BE;">{{ Type }} </span>
            <span style="text-align:left; font-weight: 700; font-size:40px">
              {{ Type_Max }}
            </span>
            <span
              style="text-align:center; font-weight: 600; font-size:20px"
            >
              คัน/วัน
            </span>
          </foreignObject>
          <path
            d="M16.5 143.5L1 128V8.5H318.693L331.5 0.5H357V8.5V128L341.5 143.5H16.5Z"
            stroke="#00B058"
          />
          <path
            d="M324.5 0H328.5L317.5 7H313.5L324.5 0Z"
            fill="#00B058"
          />
          <path
            d="M317.5 0H321.5L310.5 7H306.5L317.5 0Z"
            fill="#00B058"
          />
          <path
            d="M310.5 0H314.5L303.5 7H299.5L310.5 0Z"
            fill="#00B058"
          />
          <path
            d="M303.5 0H307.5L296.5 7H292.5L303.5 0Z"
            fill="#00B058"
          />
          <path
            d="M296.5 0H300.5L289.5 7H285.5L296.5 0Z"
            fill="#00B058"
          />
          <path
            d="M289.5 0H293.5L282.5 7H278.5L289.5 0Z"
            fill="#00B058"
          />
        </svg>
      </b-col>
      <b-col
        lg="3"
        md="3"
      >
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 358 144"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <foreignObject
            x="15"
            y="20"
            width="350"
            height="150"
            color="#ffffff"
            font-size="20"
          >
            <svg
              width="32"
              height="32"
              viewBox="0 0 32 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M4 4V28H28"
                stroke="#BB6BD9"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M7.59998 24.4C7.59998 24.4 10.7875 4 17.8 4C24.8125 4 28 24.4 28 24.4"
                stroke="#BB6BD9"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M7.59998 16H28"
                stroke="#BB6BD9"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-dasharray="2 4"
              />
            </svg>
          </foreignObject>
          <foreignObject
            width="100%"
            height="100%"
            x="65"
            y="25"
          >
            <div>
              <span style="font-size:20px; font-weight: 600; color: #fff;">Average Speed</span>
            </div>
          </foreignObject>
          <foreignObject
            width="100%"
            height="100%"
            x="320"
            y="25"
          >
            <feather-icon
              id="popover-average"
              icon="AlertCircleIcon"
              size="24"
              stroke="#F9A600"
            />
            <b-popover
              target="popover-average"
              triggers="focus"
              placement="left"
            >
              <b-img
                src="@/assets/images/formula/avergespeed.jpeg"
              />
            </b-popover>
          </foreignObject>
          <foreignObject
            x="20"
            y="70"
            width="100%"
            height="100%"
            color="#ffffff"
          >
            <span style="text-align:left; font-weight: 700; font-size:40px">
              {{ SpeedAVG }}
            </span>
            <span
              style="text-align:center; font-weight: 600; font-size:20px"
            >
              กม./ชม.
            </span>
          </foreignObject>
          <path
            d="M16.5 143.5L1 128V8.5H318.693L331.5 0.5H357V8.5V128L341.5 143.5H16.5Z"
            stroke="#00B058"
          />
          <path
            d="M324.5 0H328.5L317.5 7H313.5L324.5 0Z"
            fill="#00B058"
          />
          <path
            d="M317.5 0H321.5L310.5 7H306.5L317.5 0Z"
            fill="#00B058"
          />
          <path
            d="M310.5 0H314.5L303.5 7H299.5L310.5 0Z"
            fill="#00B058"
          />
          <path
            d="M303.5 0H307.5L296.5 7H292.5L303.5 0Z"
            fill="#00B058"
          />
          <path
            d="M296.5 0H300.5L289.5 7H285.5L296.5 0Z"
            fill="#00B058"
          />
          <path
            d="M289.5 0H293.5L282.5 7H278.5L289.5 0Z"
            fill="#00B058"
          />
        </svg>
      </b-col>
      <b-col
        lg="3"
        md="3"
      >
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 358 144"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <foreignObject
            width="100%"
            height="100%"
            x="20"
            y="20"
          >
            <div>
              <b-img
                src="@/assets/images/icons/count4.svg"
              />
            </div>
          </foreignObject>
          <foreignObject
            width="100%"
            height="100%"
            x="65"
            y="25"
          >
            <div>
              <span style="font-size:20px; font-weight: 600; color: #fff;">85th Percentile Speed</span>
            </div>
          </foreignObject>
          <foreignObject
            width="100%"
            height="100%"
            x="320"
            y="25"
          >
            <feather-icon
              id="popover-Percentile"
              icon="AlertCircleIcon"
              size="24"
              stroke="#F9A600"
            />
            <b-popover
              target="popover-Percentile"
              triggers="focus"
              placement="left"
            >
              <b-img
                src="@/assets/images/formula/th85.jpeg"
                fluid
              />
            </b-popover>
          </foreignObject>
          <foreignObject
            x="20"
            y="70"
            width="100%"
            height="100%"
            color="#ffffff"
          >
            <span style="text-align:left; font-weight: 700; font-size:40px">
              {{ Speed85 }}
            </span>
            <span
              style="text-align:center; font-weight: 600; font-size:20px"
            >
              กม./ชม.
            </span>
          </foreignObject>
          <path
            d="M16.5 143.5L1 128V8.5H318.693L331.5 0.5H357V8.5V128L341.5 143.5H16.5Z"
            stroke="#00B058"
          />
          <path
            d="M324.5 0H328.5L317.5 7H313.5L324.5 0Z"
            fill="#00B058"
          />
          <path
            d="M317.5 0H321.5L310.5 7H306.5L317.5 0Z"
            fill="#00B058"
          />
          <path
            d="M310.5 0H314.5L303.5 7H299.5L310.5 0Z"
            fill="#00B058"
          />
          <path
            d="M303.5 0H307.5L296.5 7H292.5L303.5 0Z"
            fill="#00B058"
          />
          <path
            d="M296.5 0H300.5L289.5 7H285.5L296.5 0Z"
            fill="#00B058"
          />
          <path
            d="M289.5 0H293.5L282.5 7H278.5L289.5 0Z"
            fill="#00B058"
          />
        </svg>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BRow, BCol, BImg, BPopover,
} from 'bootstrap-vue'
import axios from '@axios'

export default {
  components: {
    BRow,
    BCol,
    BImg,
    BPopover,
  },
  data() {
    return {
      Total: '',
      Type_Max: '',
      Type: '',
      Speed_Max: '',
      Speed85: 0,
      SpeedAVG: 0,
    }
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  mounted() {
    this.getSumCount()
    this.getFormula()
    this.interval = setInterval(() => {
      this.getSumCount()
      this.getFormula()
    }, 300000)
  },
  methods: {
    getFormula() {
      axios
        .post('/getFormulaCountDetail', { wid: this.$route.query.wid })
        .then(response => {
          // eslint-disable-next-line prefer-destructuring
          this.Speed85 = response.data[0].Speed85
          this.SpeedAVG = response.data[0].SpeedAVG
        })
        .catch(error => {
          console.log(error)
        })
    },
    getSumCount() {
      axios
        .post('/getSumCountDetail', { wid: this.$route.query.wid })
        .then(response => {
          this.Total = response.data[0].Total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
          this.Type_Max = response.data[0].Type_Max.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
          this.Speed_Max = response.data[0].Speed_Max.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')

          if (response.data[0].Type_Max === response.data[0].Bike && response.data[0].Type_Max !== 0) {
            this.Type = 'จักรยานยนต์'
          } else if (response.data[0].Type_Max === response.data[0].Car && response.data[0].Type_Max !== 0) {
            this.Type = 'รถยนต์'
          } else if (response.data[0].Type_Max === response.data[0].Truck && response.data[0].Type_Max !== 0) {
            this.Type = 'รถบรรทุก'
          } else if (response.data[0].Type_Max === response.data[0].Bus && response.data[0].Type_Max !== 0) {
            this.Type = 'รถบัส'
          } else if (response.data[0].Type_Max === response.data[0].Taxi && response.data[0].Type_Max !== 0) {
            this.Type = 'รถแท็กซี่'
          } else if (response.data[0].Type_Max === response.data[0].Pickup && response.data[0].Type_Max !== 0) {
            this.Type = 'รถกระบะ'
          } else if (response.data[0].Type_Max === response.data[0].Trailer && response.data[0].Type_Max !== 0) {
            this.Type = 'รถพ่วง'
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
  },
}
</script>

<style>
</style>
